import gql from 'graphql-tag'

import { ChildFieldsFragment } from 'main/gql/child'
import {
  SchoolFieldsFragment,
  SchoolWithDirectorFieldsFragment,
  SchoolWithProfileFieldsFragment,
} from 'main/gql/school'
import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'
import { DesiredWeeklyScheduleFieldsFragment } from '../../../../gql/desiredWeeklySchedule'

export const REQUEST_TOUR_MODAL_QUERY = gql`
  query RequestTourModal($schoolId: Int!) {
    school(id: $schoolId) {
      ...SchoolFields
      ...SchoolWithDirectorFields
      ...SchoolWithProfileFields
    }
    user {
      children {
        ...ChildFields
      }
      ...UserFields
      ...UserWithFamilyFields
    }
    tourRequests(schoolId: $schoolId) {
      id
      availabilities {
        beginsAt
      }
      child {
        id
      }
    }
    desiredWeeklySchedule {
      ...DesiredWeeklyScheduleFields
    }
  }

  ${SchoolFieldsFragment}
  ${SchoolWithDirectorFieldsFragment}
  ${SchoolWithProfileFieldsFragment}
  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
  ${ChildFieldsFragment}
  ${DesiredWeeklyScheduleFieldsFragment}
`
